import React from 'react'
import { useNavigate } from 'react-router'
import { Box, Stack, Button, Heading, Text, ConfirmButton, Alert } from '@/components/lib'
import utils from '@/utils/utils'
import api from '../../../api'
import useStore from '../../../store'

export default function DeleteSettings ({ trial }) {
  const navigate = useNavigate()
  const { setTrial, trials, setTrials } = useStore()

  function deleteTrial () {
    api.trials.delete(trial._id, () => {
      utils.toast('success', 'Trial deleted', 'We\'ve deleted the trial and its data.')
      setTrial(null)
      setTrials(trials.filter(t => t._id !== trial._id))
      navigate('/trials')
    }, err => utils.toast('error', err.message))
  }
  return (
    <Alert status='warning' rounded='md' shadow='lg'>
      <Stack gap={3}>
        <Heading as='h3' size='md'>Delete trial</Heading>
        <Text>Deleting the trial will also de-register all participants and delete all responses and data.</Text>
        <Box>
          <ConfirmButton
            trigger={<Button colorPalette='red'>Delete trial</Button>}
            header='Really delete this trial?'
            body='All associated data will be removed.'
            footer='This action is non-reversible.'
            onConfirm={deleteTrial}
            actionColor='red'
          />
        </Box>
      </Stack>
    </Alert>
  )
}
